<template>
  <b-overlay :show="loading">
    <div class="behavioral-record-container p-4">
      <div class="card shadow-sm border-0">
        <div class="card-header bg-light-blue py-3 text-center border-bottom">
          <p class="mb-1 font-weight-bold" style="color: #333; font-size: 0.85rem">Bangladesh Gazette - বাংলাদেশ গেজেট</p>
          <h5 class="mb-1 font-weight-bold text-primary">Form No: 07</h5>
          <p class="mb-1 text-muted small">Under Section 7, Rules (1) and (2)</p>
          <p class="mb-1 text-muted small">Fifth Part (E)</p>
          <h6 class="mb-0 font-weight-bold">Behavioral Record</h6>
          <p class="mb-0 small bn-text">আচরণের রেকর্ড</p>
        </div>

        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="table table-bordered mb-0 custom-table">
              <thead class="text-center bg-light-cyan">
                <tr>
                  <th
                    width="15%"
                    @click="sortBy('date')"
                    :class="sortKey == 'date' ? (sortOrders['date'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                    style="cursor: pointer"
                  >
                    Date<br /><small class="bn-text">তারিখ</small>
                  </th>
                  <th
                    @click="sortBy('description')"
                    :class="sortKey == 'description' ? (sortOrders['description'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                    style="cursor: pointer"
                  >
                    Behavioral Description<br /><small class="bn-text">আচরণের বিবরণ</small>
                  </th>
                  <th width="15%">
                    Worker's Signature<br />
                    <small class="bn-text">শ্রমিকের স্বাক্ষর</small>
                  </th>
                  <th width="15%">
                    Thumb Impression<br />
                    <small class="bn-text">টিপসই</small>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="paginatedData.length == 0 && !loading">
                  <td colspan="4" class="text-center py-5 text-muted">
                    No records found.<br /><span class="bn-text">কোন তথ্য পাওয়া যায়নি</span>
                  </td>
                </tr>
                <tr v-for="item in paginatedData" :key="item.id" class="text-center">
                  <td>{{ formatDate(item.date) }}</td>
                  <td class="text-left">
                    <div class="font-weight-bold">{{ getJsonValue(item.description, 'en') }}</div>
                    <div class="bn-text small text-muted">{{ getJsonValue(item.description, 'bn') }}</div>
                  </td>
                  <td>
                    <b-link v-if="item.worker_signature" @click="downloadWithName(item.worker_signature, 'Worker_Signature')">
                      <b-icon icon="download" scale="1.2"></b-icon> Download
                    </b-link>
                  </td>
                  <td>
                    <b-link v-if="item.worker_thumb_impression" @click="downloadWithName(item.worker_thumb_impression, 'Thumb_Impression')">
                      <b-icon icon="download" scale="1.2"></b-icon> Download
                    </b-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="card-footer bg-white border-top py-3" v-if="pagination.pages > 1">
          <b-pagination-nav
            v-model="pagination.currentPage"
            :number-of-pages="pagination.pages"
            base-url="#"
            prev-text="Previous"
            next-text="Next"
            first-number
            last-number
            align="center"
            class="mb-0"
          ></b-pagination-nav>
        </div>
      </div>
    </div>
  </b-overlay>
</template>

<script>
export default {
  data() {
    var columns = [
      { label: 'Date', name: 'date', type: 'date' },
      { label: 'Description', name: 'description' },
    ];
    var sortOrders = {};
    columns.forEach(function(col) { sortOrders[col.name] = -1; });
    return {
      apiPrefix: "/front/service-book",
      items: [],
      loading: false,
      columns: columns,
      sortKey: 'date',
      sortOrders: sortOrders,
      length: 10,
      pagination: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', pages: 1 },
    };
  },
  computed: {
    filteredData() {
      var sortKey = this.sortKey;
      var order = this.sortOrders[sortKey] || 1;
      var list = this.items.slice();
      if (sortKey) {
        var index = this.getIndex(this.columns, 'name', sortKey);
        list = list.sort(function(a, b) {
          var av = String(a[sortKey]).toLowerCase();
          var bv = String(b[sortKey]).toLowerCase();
          if (this.columns[index] && this.columns[index].type && this.columns[index].type === 'date') {
            return (av == bv ? 0 : new Date(av).getTime() > new Date(bv).getTime() ? 1 : -1) * order;
          }
          return (av == bv ? 0 : av > bv ? 1 : -1) * order;
        }.bind(this));
      }
      return list;
    },
    paginatedData() {
      return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
    },
  },
  created() { this.fetchData(); },
  methods: {
    fetchData() {
      this.loading = true;
      axios.post(this.$api_url + this.apiPrefix + "/behavioral-records/fetch", {})
        .then(res => {
          this.items = res.data || [];
          this.items.forEach(item => {
            if (item.owner_signature) this.fetchAsBlob(item.owner_signature).then(b => this.$set(item, '_ownerBlob', b));
            if (item.worker_signature) this.fetchAsBlob(item.worker_signature).then(b => this.$set(item, '_workerBlob', b));
            if (item.worker_thumb_impression) this.fetchAsBlob(item.worker_thumb_impression).then(b => this.$set(item, '_thumbBlob', b));
          });
        })
        .catch(() => {
          this.$bvToast.toast('Error loading records', { title: 'Error', variant: 'danger', solid: true });
        })
        .finally(() => { this.loading = false; });
    },
    fetchAsBlob(url) {
      if (!url) return Promise.resolve(null);
      if (url.startsWith('data:')) return Promise.resolve(url);
      return fetch(url, { credentials: 'same-origin' }).then(r => r.blob()).then(blob => URL.createObjectURL(blob)).catch(() => url);
    },
    getJsonValue(field, lang) {
      if (!field) return '';
      if (typeof field === 'object' && field !== null) return field[lang] || '';
      try { const parsed = JSON.parse(field); return parsed[lang] || ''; } catch (e) { return field; }
    },
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      if (isNaN(d.getTime())) return date.substring(0, 10);
      return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
    },
    downloadPdf(lang = 'both') {
      this.loading = true;
      axios.post(this.$api_url + this.apiPrefix + '/download-behavioral-records-pdf', { lang }, { responseType: 'blob' })
        .then(res => { this.global_download_file_content(res); })
        .finally(() => { this.loading = false; });
    },
    downloadWithName(path, name) {
      if (!path) return;
      if (path.startsWith('data:image/')) {
        try {
          const parts = path.split(';base64,');
          const contentType = parts[0].split(':')[1];
          const raw = window.atob(parts[1]);
          const uInt8Array = new Uint8Array(raw.length);
          for (let i = 0; i < raw.length; ++i) uInt8Array[i] = raw.charCodeAt(i);
          const blob = new Blob([uInt8Array], { type: contentType });
          const blobUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = name + '.' + contentType.split('/')[1];
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
          return;
        } catch (e) {
          console.error('Base64 download failed, falling back to direct URL', e);
        }
      }
      const url = path.startsWith('http') || path.startsWith('data:') ? path : '/' + path;
      const link = document.createElement('a');
      link.href = url;
      link.download = name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  }
};
</script>

<style scoped>
.bn-text        { font-family: 'notosansbengali', sans-serif; }
.bg-light-blue  { background-color: rgb(234, 246, 255) !important; }
.bg-light-cyan  { background-color: #e3f2fd; }
.custom-table th { font-size: 0.85rem; vertical-align: middle; }
.custom-table td { vertical-align: middle; font-size: 0.9rem; }
.sig-thumb { max-height: 40px; max-width: 100px; }
/* Sorting styles */
.sorting { position: relative; padding-right: 30px !important; }
.sorting:after, .sorting:before { position: absolute; bottom: 0.9em; display: block; opacity: 0.3; font-family: 'Font Awesome 5 Free'; font-weight: 900; }
.sorting:before { right: 1em; content: "\f0de"; }
.sorting:after  { right: 1em; content: "\f0dd"; top: 1.1em; }
.sorting_asc:before  { opacity: 1; }
.sorting_desc:after  { opacity: 1; }
</style>
